/**
 * Opens the top-level header nav dropdown / mega-menu panels on mouseenter
 * and closes them on mouseleave (with a short delay to prevent flicker when
 * moving the pointer between the summary and the panel), for pointer
 * devices that support true hover.
 *
 * This only adds hover behavior on top of Dawn's native <details>/<summary>
 * disclosure. Click and keyboard (Enter/Space to toggle, Escape to close,
 * Tab to move focus) behavior is untouched — see assets/global.js, which
 * still owns aria-expanded on click and Escape-to-close.
 */
(function () {
  var HOVER_MEDIA_QUERY = '(hover: hover) and (pointer: fine)';
  var CLOSE_DELAY = 150;

  function initHoverMenus() {
    if (!window.matchMedia(HOVER_MEDIA_QUERY).matches) return;

    document.querySelectorAll('.header__inline-menu header-menu').forEach(function (menu) {
      var details = menu.querySelector(':scope > details');
      var summary = details && details.querySelector(':scope > summary');
      if (!details || !summary) return;

      var closeTimer = null;

      function open() {
        clearTimeout(closeTimer);
        if (!details.hasAttribute('open')) {
          details.setAttribute('open', '');
          summary.setAttribute('aria-expanded', 'true');
        }
      }

      function scheduleClose() {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          if (details.hasAttribute('open') && !details.contains(document.activeElement)) {
            details.removeAttribute('open');
            summary.setAttribute('aria-expanded', 'false');
          }
        }, CLOSE_DELAY);
      }

      menu.addEventListener('mouseenter', open);
      menu.addEventListener('mouseleave', scheduleClose);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHoverMenus);
  } else {
    initHoverMenus();
  }
})();
